import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  icon: Icon, 
  isLoading,
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-semibold transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-[var(--primary)] text-white hover:bg-[var(--primary-hover)] shadow-md',
    secondary: 'bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 shadow-sm',
    ghost: 'bg-transparent text-slate-400 hover:text-slate-900 hover:bg-slate-50',
    danger: 'bg-[var(--danger)] text-white hover:bg-[var(--danger-hover)] shadow-md',
    outline: 'bg-transparent text-[var(--primary)] border-2 border-[var(--primary)] hover:bg-[var(--primary)] hover:text-white',
    accent: 'bg-[#042f2e] text-white hover:bg-[#021a19] shadow-md',
    // Soft emerald chip — the "all clear" state (e.g. the conflict-check
    // button after a clean check). Chip-toned, not solid, so Publish (accent)
    // stays the loudest control in any toolbar.
    success: 'bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 shadow-sm',
  };

  const sizes = {
    xs: 'px-1.5 py-0.5 text-[9px]',
    sm: 'px-2.5 py-1 text-[11px]',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-2.5 text-base',
    icon: 'p-2',
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={isLoading || props.disabled}
      style={{ borderRadius: 'var(--radius-md)' }}
      {...props}
    >
      {isLoading ? (
        <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : Icon && <Icon className={size === 'icon' ? 'w-5 h-5' : (size === 'xs' ? 'w-3 h-3' : 'w-4 h-4')} />}
      {size !== 'icon' && children}
    </button>
  );
};

export default Button;
